/**
 * Kinly — Capgo Live Updates bootstrap.
 *
 * Strategy: we ONLY call notifyAppReady() (so the plugin won't roll back
 * the current bundle) and let the plugin's autoUpdate machinery handle
 * the download + apply timing by itself, per capacitor.config.ts
 * (directUpdate: false → apply on next cold start; resetWhenUpdate: true).
 *
 * Why we REMOVED the mid-session CapacitorUpdater.set({id}) call:
 *   Forcing set() while the user is navigating reloads the WebView in
 *   the middle of a session. That looks like a hang ("the entire app
 *   froze after clicking Today → Plan → Talk") because the WebView
 *   blanks, fetches the new bundle from disk, and re-mounts the React
 *   tree — wiping any pending API call, route, or sheet state.
 *
 *   The plugin already applies the downloaded bundle on the NEXT cold
 *   start (directUpdate: false). That's the correct, unsurprising UX:
 *   the user closes Kinly, opens it again, and sees the new bundle —
 *   never mid-task.
 */
import { Capacitor } from "@capacitor/core";

let initialised = false;

export async function initLiveUpdates() {
  if (initialised) return;
  initialised = true;
  if (!Capacitor.isNativePlatform()) return;

  try {
    const { CapacitorUpdater } = await import("@capgo/capacitor-updater");
    // notifyAppReady() tells the plugin the current bundle booted
    // successfully — without it, the plugin auto-rolls back to the
    // previous bundle after a few seconds, thinking the new one
    // crashed.
    await CapacitorUpdater.notifyAppReady();
    // No updateAvailable listener: we deliberately do NOT call set()
    // mid-session. The plugin will apply downloaded bundles on the
    // next cold start (capacitor.config.ts → directUpdate: false).
  } catch (err) {
    console.warn("[Kinly] Live Updates init failed:", err?.message || err);
  }
}
